export enum JobRoleType {
  BoardLevel = "Board level",
  ClinicalOrOperationalManagement = "Clinical or operational management",
  ServicesAndCorporate = "Services and corporate",
}
